import { gql } from '@apollo/client'

// Query to get a list of Payment Terms (Brief)
export const PAYMENT_TERMS_QUERY = gql`
  query PaymentTerms {
    paymentTerms {
      paymentTermID
      name
      paymentTermCode
      displayPaymentTermCode
    }
  }
`

// Query to get a specific Payment Term by ID
export const PAYMENT_TERM_QUERY = gql`
  query PaymentTerm($paymentTermID: ID!) {
    paymentTerm(paymentTermID: $paymentTermID) {
      paymentTermID
      name
      paymentTermCode
      displayPaymentTermCode
      referenceTime
      gracePeriodDays
      penaltyAdministrationFee
      earlyPaymentDiscountPercentage
      proformaExpirationDuration
      proformaPaymentDeadlineDuration
      paymentTermDetails {
        fromDay
        toDay
        infiniteTo
        penaltyPercent
        penaltyFeeDaily
        penaltyBaseDaily
        penaltyTermDetailID
      }
    }
  }
`
// Mutation to create a new Payment Term
export const CREATE_PAYMENT_TERM_MUTATION = gql`
  mutation CreatePaymentTerm($input: PaymentTermInput!) {
    createPaymentTerm(input: $input) {
      message
    }
  }
`

export const REFERENCE_TIMES_QUERY = gql`
  query ReferenceTimes {
    referenceTimes
  }
`

export const PAYMENT_TERM_ASSIGNMENTS_QUERY = gql`
  query PaymentTermAssignmentsOfAWallet(
    $walletID: ID!
    $range: DateRangeInput
  ) {
    paymentTermAssignmentsOfAWallet(walletID: $walletID, range: $range) {
      id
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
      assignments {
        paymentTermCode
        displayPaymentTermCode
        paymentTermName
        assignmentTimeRange {
          from
          to
        }
      }
    }
  }
`
